module.exports = __webpack_public_path__ + "sp_slide_mobile.jpg";